import { render, staticRenderFns } from "./HadiahList.vue?vue&type=template&id=0348bff0"
import script from "./HadiahList.vue?vue&type=script&lang=js"
export * from "./HadiahList.vue?vue&type=script&lang=js"
import style0 from "./HadiahList.vue?vue&type=style&index=0&id=0348bff0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardActions,VContainer})
